var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("DialogLayout", {
    attrs: { title: "詳細情報", visible: _vm.dialogVisible, width: "65em" },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      },
      open: _vm.open
    },
    scopedSlots: _vm._u(
      [
        {
          key: "form",
          fn: function() {
            return [
              _c("FeesForSecurityForm", {
                ref: "feesForSecurityForm",
                attrs: {
                  "label-width": "10em",
                  formMode: "edit",
                  billingYmMode: "search",
                  editDisabledMode: _vm.editDisabledMode,
                  "autocomplete-airport-code-set": _vm.airportCodeSet,
                  "autocomplete-customer-code-set": _vm.customerCodeSet
                },
                model: {
                  value: _vm.feesForSecurityFormModel,
                  callback: function($$v) {
                    _vm.feesForSecurityFormModel = $$v
                  },
                  expression: "feesForSecurityFormModel"
                }
              })
            ]
          },
          proxy: true
        },
        !_vm.editDisabledMode
          ? {
              key: "footer",
              fn: function() {
                return [
                  _c("EditDialogFooter", { on: { update: _vm.clickUpdate } })
                ]
              },
              proxy: true
            }
          : null
      ],
      null,
      true
    )
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }